<template>
  <div class="itemslicksub">
    <slick
      v-if="images && images.length"
      class="js-gallery-thumb gallery gallery--thumb"
      ref="slick"
      :options="slickOptions"
      @afterChange="handleAfterChange"
      @beforeChange="handleBeforeChange"
      @breakpoint="handleBreakpoint"
      @destroy="handleDestroy"
      @edge="handleEdge"
      @init="handleInit"
      @reInit="handleReInit"
      @setPosition="handleSetPosition"
      @swipe="handleSwipe"
      @lazyLoaded="handleLazyLoaded"
      @lazyLoadError="handleLazeLoadError"
    >
      <div
        v-for="(img,i) in images"
        :key="i"
        @click="goto(i)"
        :class="{'active' : goToimg == i }"
        class="item p-2 inner-middle text-center"
      >
        <div class="thumb">
          <img class="item__img inner-middle text-center" :src="img.url">
        </div>
      </div>
    </slick>
  </div>
</template>
<script>
import Slick from "vue-slick";
export default {
  name: "itemslicksub",
  components: {
    Slick
  },
  props: {
    images: Array,
    goToimg: Number
  },
  data() {
    return {
      slickOptions: {
        asNavFor: ".js-gallery-main",
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true
      }
    };
  },
  computed: {},
  methods: {
    goto(val) {
      this.$parent.goToimg = val;
    },
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {},
    handleBeforeChange(event, slick, currentSlide, nextSlide) {},
    handleBreakpoint(event, slick, breakpoint) {},
    handleDestroy(event, slick) {},
    handleEdge(event, slick, direction) {},
    handleInit(event, slick) {},
    handleReInit(event, slick) {},
    handleSetPosition(event, slick) {},
    handleSwipe(event, slick, direction) {},
    handleLazyLoaded(event, slick, image, imageSource) {},
    handleLazeLoadError(event, slick, image, imageSource) {}
  }
};
</script>

<style lang="scss" scoped>
.inner-middle .thumb {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.inner-middle.active .thumb {
  border-color: #000 !important;
}
</style>